var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statusBody"},[_c('div',{staticClass:"color",style:({
      background: _vm.colorList[_vm.type],
    })}),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }